export default __webpack_public_path__ + "static/media/Hair_1_M_C4.01c44f7c.svg";